var map = {
	"./icon-arrow.svg": "515e",
	"./icon-briefcase.svg": "63cd",
	"./icon-change-password-key.svg": "5f38",
	"./icon-danger.svg": "9929",
	"./icon-dismiss.svg": "0c3e",
	"./icon-download.svg": "ac3e",
	"./icon-edit.svg": "f9ca",
	"./icon-fb.svg": "a990",
	"./icon-google.svg": "45ae",
	"./icon-herbarium.svg": "4482",
	"./icon-mail.svg": "86cf",
	"./icon-navigate-circle.svg": "f2fc",
	"./icon-school.svg": "8a66",
	"./icon-success.svg": "4766",
	"./icon-timer-outline.svg": "99b1",
	"./icon-warning.svg": "9e44"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5be7";